"use client";

import type { UseRequestInfiniteQueryProps } from "../../../../request/hooks/useRequestInfiniteQuery";
import { useRequestInfiniteQuery } from "../../../../request/hooks/useRequestInfiniteQuery";
import { keyCollectionPrayers } from "./keyCollectionPrayers";
import type { CollectionPrayers } from "./schema/collectionsPrayersSchema";
import { collectionPrayersSchema } from "./schema/collectionsPrayersSchema";

export type UseRequestCollectionPrayersProps = UseRequestInfiniteQueryProps & {
  id: number;
};

export const useRequestCollectionPrayers = ({
  id,
  ...props
}: UseRequestCollectionPrayersProps) => ({
  infiniteQuery: useRequestInfiniteQuery({
    getNextPageParam: (lastPage: CollectionPrayers) =>
      lastPage?.[lastPage?.length - 1]?.id || null,
    initialPageParam: -1,
    enabledWithoutSessionToken: false,
    ...props,
    queryFnRequestProps: ({ pageParam }) => {
      const searchParams = new URLSearchParams("?page_size=100");
      if (pageParam && pageParam !== -1)
        searchParams.set("last_id", pageParam as string);

      return {
        schema: collectionPrayersSchema,
        urlBackendPath: `/collections/${id}/prayers${searchParams.toString().length > 0 ? `?${searchParams.toString()}` : ""}`,
      };
    },
    queryKey: keyCollectionPrayers({ id }),
  }),
});
